module.exports = __webpack_public_path__ + "img/leaf.fdd4d583.png";